import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_V_L, TS_Input, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { ThisShouldNotHappenException } from '@nu-art/ts-common';
import { ModuleFE_Account, SessionKeyFE_Account } from '../../_entity.js';
export class Component_ChangePassword extends ComponentSync {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        const account = SessionKeyFE_Account.get();
        if (!account)
            throw new ThisShouldNotHappenException('Rendering a change password component without user logged in');
        state.shouldGiveCurrentPassword = account.hasPassword;
        return state;
    }
    // ######################## Logic ########################
    submitNewPassword = async () => {
        if (!this.state.newPassword || !this.state.newPasswordCheck) {
            this.logError('No password or password check');
            return;
        }
        try {
            if (!this.state.shouldGiveCurrentPassword)
                await ModuleFE_Account._v1.setPassword({
                    password: this.state.newPassword,
                    passwordCheck: this.state.newPasswordCheck,
                }).executeSync();
            else {
                if (!this.state.currentPassword) {
                    this.logError('No current password given');
                    return;
                }
                await ModuleFE_Account._v1.changePassword({
                    oldPassword: this.state.currentPassword,
                    password: this.state.newPassword,
                    passwordCheck: this.state.newPasswordCheck,
                }).executeSync();
            }
            this.props.postSubmitAction?.();
        }
        catch (e) {
            this.logError(e);
        }
    };
    // ######################## Render ########################
    renderCurrentPassword = () => {
        if (!this.state.shouldGiveCurrentPassword)
            return '';
        return _jsx(TS_PropRenderer.Vertical, { label: 'Current Password', children: _jsx(TS_Input, { type: 'password', value: this.state.currentPassword, onChange: val => this.setState({ currentPassword: val }) }) });
    };
    render() {
        return _jsxs(LL_V_L, { className: 'ts-account__change-password', children: [this.renderCurrentPassword(), _jsx(TS_PropRenderer.Vertical, { label: 'New Password', children: _jsx(TS_Input, { type: 'password', value: this.state.newPassword, onChange: val => this.setState({ newPassword: val }) }) }), _jsx(TS_PropRenderer.Vertical, { label: 'New Password Check', children: _jsx(TS_Input, { type: 'password', value: this.state.newPasswordCheck, onChange: val => this.setState({ newPasswordCheck: val }) }) }), _jsx(Button, { variant: 'primary', onClick: this.submitNewPassword, children: "Submit" })] });
    }
}
//# sourceMappingURL=Component_ChangePassword.js.map